import { gql } from 'graphql-tag';

const apmsLocationContactsQuery = gql`
  query apmsLocationContactsList($page: Int, $size: Int, $isPaginationActive: Boolean) {
    apmsLocationContactsList(page: $page, size: $size, isPaginationActive: $isPaginationActive) {
      auctionName
      blockedEmail
      contactEmail
      contactId
      contactName
      contactType
      createdAt
      guaranteeCancel
      guaranteeConfirm
      isBlockedEmail
      locationId
      phone
      returns
      title
      updatedAt
      vehNotCovered
    }
  }
`;

export default apmsLocationContactsQuery;
